module.exports = __webpack_public_path__ + "img/sint-maarten-(dutch-part).ab83ac98.svg";